import React from 'react';
import { Gift, ArrowRight } from 'lucide-react';
import { PORTAL_REFERRALS_URL } from '../utils/ctaUrl';

/**
 * Phase 1.5 — Referral teaser.
 * Refer a friend → they get RM50 off their first booking; you earn RM30 credit
 * after they book. Reward only fires after a valid transaction.
 *
 * CTA links directly to the portal's /referrals page (invite code + copy-link
 * + share-on-WhatsApp UI). Already-logged-in users land there straight away;
 * logged-out users are bounced by the portal's auth guard to /login?from=/referrals
 * and then dropped on /referrals after a successful login.
 */
export default function ReferralBanner({ className = '' }) {
  return (
    <div className={`relative overflow-hidden rounded-2xl border border-brand-200 bg-gradient-to-br from-brand-50 via-white to-icy ${className}`}>
      <div className="absolute -right-20 -top-20 w-64 h-64 bg-misty/40 blur-3xl rounded-full pointer-events-none" />
      <div className="relative p-6 sm:p-8 grid sm:grid-cols-[auto_1fr_auto] gap-5 items-center">
        <div className="w-14 h-14 rounded-2xl bg-white border border-brand-200 text-brand-700 flex items-center justify-center shrink-0">
          <Gift size={26} />
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] font-semibold text-brand-700">
            Refer · Earn · Repeat
          </div>
          <h3 className="mt-1 text-lg sm:text-xl font-semibold text-ink-900">
            Refer a friend, earn RM30 credit.
          </h3>
          <p className="mt-1 text-sm text-ink-600">
            They get <strong className="text-ink-900">RM50 off</strong> their first booking. You earn{' '}
            <strong className="text-ink-900">RM30 in credits</strong> after they complete their visit.
          </p>
        </div>
        <a
          href={PORTAL_REFERRALS_URL}
          className="inline-flex items-center gap-2 font-medium rounded-full px-5 py-3 text-sm bg-ink-900 text-white hover:bg-ink-800 transition-colors whitespace-nowrap"
        >
          Get my link <ArrowRight size={16} />
        </a>
      </div>
    </div>
  );
}
